import { hasDefaultAction } from 'modules/automation-rules/actions/utils/has-default-action'
import { hasDefaultTrigger } from 'modules/automation-rules/triggers/utils/has-default-trigger'
import { AutomationRuleViewInterface } from 'modules/automation-rules/types/automation-rule-interface'

export const isRuleSaveDisabled = (rule: AutomationRuleViewInterface) =>
  rule.triggers.length === 0 ||
  rule.actions.length === 0 ||
  hasDefaultTrigger(rule.triggers) ||
  hasDefaultAction(rule.actions)
